import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getEntityProfileData } from "../../services/entities";

export const useEntityProfileData = ({
  entityId,
  isOwnProfile,
}: {
  entityId: string | undefined;
  isOwnProfile: boolean;
}) => {
  const { i18n } = useTranslation();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["EntityProfile", i18n.language, isOwnProfile, entityId],
    queryFn: async () => await getEntityProfileData(isOwnProfile, entityId),
  });

  return { entityInfo: data, isEntityInfoLoading: isLoading, isEntityInfoHasError: isError };
};
